import { Controller } from "stimulus"

export default class extends Controller {

    duration

    initialize() {
        document.getElementById("video").addEventListener("loadedmetadata", () => {
            this.duration = Math.floor(document.getElementById("video").duration);
            document.getElementById("video_editor_max_value").max = this.duration;
            document.getElementById("video_editor_max_value").value = this.duration;
            document.getElementById("video_editor_min_value").max = this.duration - 1;
        }, false);
    }

    updateDuration() {
        let max_value = document.getElementById("video_editor_max_value");
        let min_value = document.getElementById("video_editor_min_value");
        max_value.min = Math.min(this.duration, Number(min_value.value) + 1);
        min_value.max = Math.min(this.duration, Number(max_value.value) - 1);
    }

    calculateAudioDuration(event) {
        var obUrl;
        var file = event.target.files[0];
        if (file.name.match(/\.(mp3|wav)$/i)) {
            obUrl = URL.createObjectURL(file);
            let audio = document.getElementById('audio');
            audio.setAttribute('src', obUrl);
            audio.load();
            audio.onloadeddata = function() {
                document.getElementById("video_editor_audio_duration").value = Math.floor(audio.duration);
            }
        }
    }

    processVideo(event) {
        if (document.getElementById("video_editor_max_value").checkValidity() && document.getElementById("video_editor_min_value").checkValidity()) {
            event.target.innerText = "Processing";
        }
    }
}